const STORAGE_KEY = 'bookscape_recently_viewed';
const MAX_ITEMS = 12;

export const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const addRecentlyViewed = (book) => {
  if (!book || !book.id) return;
  const minimal = {
    id: book.id,
    title: book.title,
    author: book.author,
    image: book.image,
    price: book.price,
    originalPrice: book.originalPrice,
    discount: book.discount,
    rating: book.rating,
    reviews: book.reviews,
    viewedAt: Date.now(),
  };
  const existing = getRecentlyViewed().filter((b) => b.id !== book.id);
  const updated = [minimal, ...existing].slice(0, MAX_ITEMS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    /* quota exceeded — ignore */
  }
};

export const clearRecentlyViewed = () => {
  localStorage.removeItem(STORAGE_KEY);
};
